// frontend/src/pages/SearchResultsPage.js

import React, { useState, useEffect, useCallback } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import apiClient from '../api';
import { formatDate } from '../utils/formatDate';

function SearchResultsPage() {
  const [results, setResults] = useState([]);
  const [error, setError] = useState('');
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q');

  const fetchResults = useCallback(async () => {
    if (!query) return;
    try {
      const response = await apiClient.get(`/api/juveniles?search=${query}`);
      setResults(response.data.juveniles);
    } catch (err) {
      setError('Failed to fetch search results.');
      console.error(err);
    }
  }, [query]);

  useEffect(() => {
    fetchResults();
  }, [fetchResults]);

  if (error) return <div>Error: {error}</div>;

  return (
    <div className="card">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold text-slate-800">Search Results for "{query}"</h1>
        <Link to="/advanced-search" className="text-sm text-slate-600 hover:text-gold">
          Switch to Advanced Search
        </Link>
      </div>
      <table className="w-full text-left">
        {/* ... Table headers ... */}
        <tbody>
          {results.length > 0 ? (
            results.map(juvenile => (
              <tr key={juvenile.id} className="border-b hover:bg-slate-50">
                <td className="p-4 font-medium text-slate-800">{juvenile.first_name} {juvenile.last_name}</td>
                <td className="p-4 text-slate-600">{formatDate(juvenile.date_of_birth)}</td>
                <td className="p-4">
                  <Link to={`/juveniles/${juvenile.id}`} className="bg-gold text-white hover:bg-gold-dark font-bold py-1 px-3 rounded-lg text-sm">
                    View Profile
                  </Link>
                </td>
              </tr>
            ))
          ) : (
            <tr><td colSpan="3" className="p-4 text-center text-slate-500">No results found.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default SearchResultsPage;
